import { Component, OnInit, OnDestroy, ViewChild, WritableSignal, signal } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { ToastMessageOptions } from 'primeng/api';

import { GetMediatipsAction, UpdateMediatipAction, DeleteMediatipAction, RemoveMediaTipDoneObjectfromStoreAction, MediatipClearErrorAction } from '../store/actions';
import { selectMediatips, selectMediatipActiondone, selectMediatipsTasks, selectisLoading, selectcurrentMediatipError, selectBubData, selectmediatipsHits } from '../store/selectors';
import { filter, map } from 'rxjs/operators';
import { MediatipService } from '@app/common/services/mediatip.service';
import { AuthService } from 'FoxxyLib';
import { IMediaTip, MediaTipTask, MediatipState, IMediaMenue, MeditipActionResultEnum, MediaPresenceState, IMediaPresence, ISortOption, MediaTipActionDone, IMediaTipActions } from '@app/common/models/mediatips.models';
import { environment } from '@env/environment';
import { GeneralResultEnum } from '@app/common/models';
import { NotificationService } from '@app/common/services/notification.service';


import { SignalMessageService } from '@app/common/services/signalmessage.service';
import { SignalMessageContentModel, SendMessageObject, MessageTypeEnum, MessageStatusEnum, SendMessageTypeContainer, MessageParamter } from '@app/common/models/signal.model';
import  cloneDeep from 'lodash/fp/cloneDeep';
import { IAuthUser, IClientError } from 'FoxxyInterfaces';
import { LipoMessageService } from '@app/common/services/LipoMessageService';


import { LogUsersClientErrorAction } from '@app/store/user/actions';

import { selectNotificationsbyType } from '@app/+notifications/store/selectors';
import { DeleteAllMessagesAction, DeleteSingleMessagesAction } from '@app/+notifications/store';
import { PageSorting } from '@app/common/models/PagingSort-model';
import { Observable, combineLatest, of } from 'rxjs';
import { SimpleResult } from '@app/common/models/simpleResult.model';
import { BubDataResult } from 'FoxxyInterfaces';
import { MediatippsEditDialogComponent } from '../dialogs/mediatippsEditDialog/mediatippsEditDialog.component';
import { MessageEditDialogComponent } from '@app/+notifications/dialogs/message-edit-dialog/message-edit-dialog.component';
import { DatePicker } from 'primeng/datepicker';
import { ButtonSeverity } from 'primeng/button';




//Buttons und DropdownMenue für Mediatips aufbauen
export interface IActionbutton {
  tooltip: string;
  label: string;
  icon: string;
  severity: ButtonSeverity ,
  action(row: IMediaTip): any;
  disabled(row: IMediaTip, label: string): boolean;
  mediatip: IMediaTip;
}

export interface SortOptionTask {
  mediastate: number;
  sortoptions: ISortOption[];
}


@Component({
    selector: 'app-list-mediatips',
    templateUrl: './list-mediatips.component.html',
    styleUrls: ['./list-mediatips.component.scss'],
    providers: [MediatipService, SignalMessageService],
    standalone: false
})
export class ListMediatipsComponent implements OnInit, OnDestroy {

  allMediatips: boolean = false;
  isManager: boolean = false;
  mediaTipCols: any[];
  mediatipList: WritableSignal<Array<IMediaTip>> = signal([]);

  isAdmin: boolean = false;
  viewLoaded = false;
  menues: IMediaMenue[];
  actionbtns = new Array<IActionbutton>();
  notifications: SendMessageTypeContainer<SignalMessageContentModel>[];
  authUser: IAuthUser;
  filterfromDate: Date;
  usePaging: WritableSignal<boolean> = signal(true);
  pageSorting = new PageSorting(40);


  sortOptions = new Array<ISortOption>();
  sortColumns = [
    <ISortOption>{ mediastate: 0, name: "Versand", caption: "Erhalten am", asc: false },
    <ISortOption>{ mediastate: 0, name: "Warengruppe", caption: "Warengruppe", asc: true },
    <ISortOption>{ mediastate: 0, name: "Lieferant", caption: "Lieferant", asc: true },
    <ISortOption>{ mediastate: 0, name: "Präsenz", caption: "Präsenz", asc: true },
    <ISortOption>{ mediastate: 0, name: "Präsenzdatum", caption: "Präsenzdatum", asc: true },
  ];



  sortColumnsTasks = new Array<SortOptionTask>();
  @ViewChild('filterCalendar') datePicker: DatePicker;

  /**default Medientipps ab heute - 30 , weiter zurück mit paging   */
  startMediatippsafterDays: number = 30;
  isLoading$: Observable<boolean>;
  mediatipTasks$: Observable<MediaTipTask[]>;
  mediatipList$: Observable<IMediaTip[]>;
  selectmediatipsHits$: Observable<number> = of(0)
  errorMediatipsHandle$: Observable<SimpleResult> = of(null);
  selectMediatipActiondone$: Observable<MediaTipActionDone> = of(null);
  selectMessages$: Observable<SendMessageTypeContainer<any>[]> = of([]);
  selectBubDataDone$: Observable<BubDataResult> = of(null);
  mediatipGroups: WritableSignal<{ [key: number]: IMediaTip[] }> = signal({});
  mediatipActions: WritableSignal<{ [key: number]: IMediaTipActions }> = signal({});


  constructor(private store: Store<any>,
    private authService: AuthService,
    private confirmationsService: ConfirmationService,
    private signalmessageService: SignalMessageService,
    private dialogService: DialogService, private notifier: NotificationService,
    private lipomessageService: LipoMessageService<ToastMessageOptions>
  ) {

    this.isLoading$ = this.store.pipe(select(selectisLoading));
    this.mediatipTasks$ = this.store.pipe(select(selectMediatipsTasks));
    this.mediatipList$ = this.store.pipe(select(selectMediatips));
    this.selectmediatipsHits$ = this.store.pipe(select(selectmediatipsHits));
    this.errorMediatipsHandle$ = this.store.pipe(select(selectcurrentMediatipError));
    this.selectMediatipActiondone$ = this.store.pipe(select(selectMediatipActiondone));
    this.selectBubDataDone$ = this.store.pipe(select(selectBubData));
    this.selectMessages$ = this.store.pipe(select(selectNotificationsbyType(MessageTypeEnum.Medientipp)));


  }

  toggle(e, cm): void {
    e.preventDefault();
    e.stopPropagation();
    cm.show(e);
  }

  paginateMediatipps(e: any) {
    this.pageSorting.skipRows = e.first;
    this.pageSorting.rowsToLoad = e.rows;
    this.loadMediatips(this.allMediatips);
  }



  /* inital den Ab Wert setzen */
  setDefaultfilterDate(): void {
    this.filterfromDate = new Date();
    this.filterfromDate.setDate(this.filterfromDate.getDate() - this.startMediatippsafterDays);
    this.lastFilterDate = new Date();
  }

  ngOnInit(): void {

    this.setDefaultfilterDate();

    this.errorMediatipsHandle$.pipe(filter(t => t != undefined && (t.userMessage != undefined || t.serverMessage != undefined))).subscribe(e => {

      if (e.generalResult == GeneralResultEnum.HttpError) {
        this.lipomessageService.Clear();
        this.lipomessageService.Publish({ severity: "error", summary: e.userMessage ? e.userMessage : e.userMessage, detail: e?.serverMessage });
      } else if (e.generalResult == GeneralResultEnum.AuthError) {
        this.lipomessageService.Clear();
        this.lipomessageService.Publish({ severity: "error", summary: (e.userMessage ? e.userMessage : "Die Anmeldung ist abgelaufen"), detail: "Sie werden neu angemeldet" });

        this.authService.login();

      } else if (e.generalResult == GeneralResultEnum.OnlyDebug) {
        this.store.dispatch(new LogUsersClientErrorAction({ error: <IClientError>{ userid: this.authUser?.id, modul: 'Mediatips', error: e.userMessage + " " + e?.serverMessage } }));
      } else if (e.generalResult == GeneralResultEnum.LogicWarning) {
        this.lipomessageService.Clear();
        this.lipomessageService.Publish({ severity: "warn", summary: e.userMessage ? e.userMessage : "Fehler Mediatipps bearbeiten", detail: e.userMessage });
      } else if (e.generalResult != GeneralResultEnum.Success) {
        this.notifier.showError(e.userMessage);
        console.debug(e?.serverMessage);
      }

      this.store.dispatch(new MediatipClearErrorAction());

    });
    this.selectMediatipActiondone$.subscribe(result => {
      if (result && result.result != undefined && result.actionResult != MeditipActionResultEnum.laden) {
        this.lipomessageService.Clear();
        this.lipomessageService.Publish({ severity: "info", summary: "Medientipp " + result.result.ean + " wurde erfolgreich " + MeditipActionResultEnum[result.actionResult], detail: "" });

        if (result.actionResult == MeditipActionResultEnum.versendet && !this.isManager) {
          // Nachricht Kanal erstellen wenn Lieferant  Medientipp verschickt hat
          this.sendVerschicktNachricht(result.result);
          this.store.dispatch(new RemoveMediaTipDoneObjectfromStoreAction({}));
        }

        if (result.actionResult == MeditipActionResultEnum.angelegt
          || result.actionResult == MeditipActionResultEnum.gespeichert
          || result.actionResult == MeditipActionResultEnum.freigegeben
          || result.actionResult == MeditipActionResultEnum.versendet
        ) {
          this.store.dispatch(new RemoveMediaTipDoneObjectfromStoreAction({}));
        }
      }
    });


    combineLatest([this.mediatipList$, this.mediatipTasks$]).subscribe(([mediatips, tasks]) => {
      if (tasks && tasks.length > 0) {
      this.mediatipList.set(mediatips);
      this.viewLoaded = true;
      this.menues = new Array<IMediaMenue>();
      mediatips.forEach(item => {
        this.menues.push({
          id: item.id, menu: this.getmainMenu(item)
        });
        const mediengroups = {};
        const actions = {};
        tasks.forEach(task => {
          const result = this.getMediaTipsGroup(task);
          if (result && result.length > 0)
            {
                const grp = this.getMediaTipsGroup(task);
                mediengroups[task.mediatipState] = grp;
                grp.forEach(r => {
                  actions[r.id] = <IMediaTipActions> { menu: this.getMenu(r.id), actions: this.getcurrentActionButtons(r)  };
                }
                )
            }
        })
        this.mediatipGroups.set(mediengroups);
        this.mediatipActions.set(actions);
      })
      }
    })

    for (const state in MediatipState) {
      if (Number(state)) {
        this.sortOptions.push({ mediastate: Number(state), name: "Versand", caption: "Erhalten am", asc: false });
        this.sortColumnsTasks.push(<SortOptionTask>{ mediastate: Number(state), sortoptions: this.sortColumns });
      }
    }
    this.selectBubDataDone$.subscribe(result => {

      // es wurde gesucht nach this.mediatip.ean
      if ((!result.bubData || !result.bubData.ean) && (result.ean && result.ean.length > 12)) {
        this.lipomessageService.Clear();
        this.lipomessageService.Publish({ closable: true, severity: "warn", summary: "Zu dieser EAN sind keine Daten vorhanden", detail: "Bitte versuchen Sie eine andere EAN" });
      }
    });


    this.authService.claims$.pipe(filter(t => t.client_id), map(f => {
      return <IAuthUser>{ name: f.name, id: f.sub, client_id: f.client_id, member_of: f.member_of, }
    })).subscribe(user => {
      this.authUser = user;

      if (environment.managers.some(x => user.member_of.includes(x))) {
        this.isManager = true;
      }
      if (environment.admins.some(x => user.member_of.includes(x))) {
        this.isAdmin = true;
      }
      const sortOptionDefault = this.GetDefaultOption(this.isManager);
      this.store.dispatch(new GetMediatipsAction({ skip: this.pageSorting.skipRows, take: this.usePaging() ? this.pageSorting.rowsToLoad : 0, userid: this.authUser.id, allmediatips: this.allMediatips, sortoption: sortOptionDefault, fromDate: this.filterfromDate }));
      this.lastFilterDate = this.filterfromDate;
      this.SetSortOption(<MediaTipTask>{ mediatipState: sortOptionDefault.mediastate }, sortOptionDefault);
    })

    this.selectMessages$.subscribe(messages => {
      this.notifications = messages;
    })
  }

  ngAfterViewInit(): void {
    const that = this;
    this.datePicker.onInputKeydown = (e) => {
      if (e.key && e.key === "Enter") {
        try {
          if (e.target.value && e.target.value.length && e.target.value.length == 10) {
            const str = e.target.value;
            const dmy = str.split(".");
            const d = new Date(dmy[2], dmy[1] - 1, dmy[0]);
            that.filterfromDate = d;
            this.loadMediatipsfromDate(that.allMediatips, e);
          }
        } catch (e) {
          this.store.dispatch(new LogUsersClientErrorAction({ error: <IClientError>{ userid: this.authUser.id, modul: 'Mediatip-input', error: e } }));
        }
      }
    }
  }

  ngOnDestroy(): void {
    //teilweise store zurücksetzen
    this.store.dispatch(new RemoveMediaTipDoneObjectfromStoreAction({}));
    this.store.dispatch(new DeleteAllMessagesAction({ targetUserId: this.authUser.id, messageType: MessageTypeEnum.Medientipp }));
  }

  trackByMediatip(index: number, el: any): number {
    return el.id;
  }


  loadMediatipsfromDate(checked: boolean, event: any): void {
    try {

      this.pageSorting.skipRows = 0;


      if (!this.filterfromDate) {
        this.setDefaultfilterDate();
      }
      if (new Date(this.filterfromDate).setHours(0, 0, 0, 0) == new Date(this.lastFilterDate).setHours(0, 0, 0, 0)) return;
      this.loadMediatips(checked);
      this.datePicker.overlayVisible = false;
    } catch (e) {
      this.store.dispatch(new LogUsersClientErrorAction({ error: <IClientError>{ userid: "unknown", modul: 'Mediatip', error: e } }));
    }
  }

  lastFilterDate = new Date();
  /**Optional alle die der Manager sehen kann */
  loadMediatips(checked: boolean): void {
    if (this.filterfromDate == undefined) return;
    this.allMediatips = checked;
    const sort = this.GetDefaultOption(this.isManager);
    this.store.dispatch(new GetMediatipsAction({ skip: this.pageSorting.skipRows, take: this.usePaging() ? this.pageSorting.rowsToLoad : 0, userid: this.authUser.id, allmediatips: this.allMediatips, sortoption: sort, fromDate: this.filterfromDate }));
    this.SetSortOption(<MediaTipTask>{ mediatipState: sort.mediastate }, sort);
    this.lastFilterDate = this.filterfromDate;
  }



  /**Initiale Nachricht */
  sendVerschicktNachricht(item: IMediaTip): void {
    if (this.isManager) return; // nur von Lieferant aus
    // Message an User
    const newMessage = "Vielen Dank für Ihren Medientipp!";
    const newMessageDetails = "Der Medientipp wurde erfolgreich an Hugendubel übergeben. Bei Rückfragen kommen wir auf Sie zu.";
    this.lipomessageService.Clear();
    this.lipomessageService.Publish({ severity: "info", summary: newMessage, detail: newMessageDetails });


    //Kommunikation und Notification speichern
    const source = this.authUser.id; // an sich selbst
    const target = item.targetUserId; // Soma erstellt die pseudo Nachricht
    const messageobject = new Array<SendMessageObject<SignalMessageContentModel>>();
    const newMessageKoummunikation = "Vielen Dank für die erfolgreiche Übermittlung Ihres Medientipps. Bei Rückfragen oder Ergänzungen können wir uns gerne hier austauschen.";
    //TODO: Zur Zeit nicht ausgewertet
    //Kommunikationstart soma -> an Lieferant
    messageobject.push(<SendMessageObject<SignalMessageContentModel>>{
      id: 0,
      messageTypeId: 0,
      targetUserId: source, // lieferant
      sendDate: new Date(),
      messageStatus: MessageStatusEnum.New,
      sourceUserId: target, // von soma an Lieferant
      data: <SignalMessageContentModel>{ message: newMessageKoummunikation }
    });

    //Notification an Soma -> Bubbles
    messageobject.push(<SendMessageObject<SignalMessageContentModel>>{
      id: 0,
      messageTypeId: 0,
      targetUserId: target, //
      sendDate: new Date(),
      messageStatus: MessageStatusEnum.New,
      sourceUserId: source,
      data: <SignalMessageContentModel>{ message: "Es wurde ein neuer Medientipp für EAN " + item.ean + " angelegt." }
    });

    const messcontainer = <SendMessageTypeContainer<SignalMessageContentModel>>{
      id: 0,
      messageType: MessageTypeEnum.Medientipp,
      parentId: item.id,
      targetUserId: target,
      creatingUserId: source,           // initialer User
      messages: messageobject,
    }
    this.signalmessageService.SendMessage<SignalMessageContentModel>(messcontainer).subscribe(() => {
      // ok erledigt
    }, e => {

      this.store.dispatch(new LogUsersClientErrorAction({ error: <IClientError>{ userid: this.authUser?.id, modul: 'Mediatip-List', error: e } }));
    })
  }

  openMediatip(mediatip: IMediaTip): void {
    if (this.canAction(mediatip, "bearbeiten")) {
      this.editMediatip(mediatip);
    } else {
      this.showMediatip(mediatip);
    }
  }

  getSearchIcon(item: ISortOption): string {
    return (item.asc ? "pi pi-sort-down" : "pi pi-sort-up");
  }

  canSort(task: MediaTipTask): boolean {
    return this.isManager && task.mediatipState == MediatipState.Verschickt;
  }

  /**Sortierung der Medientipps */
  loadSort(task: MediaTipTask, event: any): void {
    const sortOption = { ...event.value };
    sortOption.mediastate = task.mediatipState;
    this.store.dispatch(new GetMediatipsAction({ skip: this.pageSorting.skipRows, take: this.usePaging() ? this.pageSorting.rowsToLoad : 0, userid: this.authUser.id, allmediatips: this.allMediatips, sortoption: sortOption, fromDate: this.filterfromDate }));
    this.lastFilterDate = this.filterfromDate;
    // sortOption.asc =  !sortOption.asc; // keine Umdehung der sortierung zur zeit
    this.SetSortOption(task, sortOption);
  }

  GetSortColumns(task: MediaTipTask): ISortOption[] {
    return this.sortColumnsTasks.filter(t => t.mediastate == task.mediatipState)[0].sortoptions;
  }

  GetDefaultOption(ismanager: boolean): ISortOption {
    const state = this.isManager ? MediatipState.Verschickt : MediatipState.Erstellt; // Nur Manager zur Zeit, erstellt liefert keine Ergebnisse für sortierung
    const liste = this.GetSortColumns(<MediaTipTask>{ mediatipState: state });
    const optchange = { ...liste.filter(t => t.name == 'Versand')[0] }; // mögliche options
    optchange.mediastate = state;
    return optchange;
  }

  SetSortOption(task: MediaTipTask, sortoption: ISortOption): void {
    const id = this.sortOptions.findIndex(t => t.mediastate == task.mediatipState); // model
    const liste = this.GetSortColumns(task);
    const optchange = liste.filter(t => t.name == sortoption.name)[0]; // mögliche options
    this.sortOptions[id] = optchange;
  }

  /**Default SortOption */
  GetSortOption(task: MediaTipTask): ISortOption {
    return this.sortOptions.filter(t => t.mediastate == task.mediatipState)[0];
  }



  /**Ermittelt die Taskgruppe */
  getMediaTipsGroup(task: MediaTipTask): IMediaTip[] {
    const result = cloneDeep(this.mediatipList().filter(t => t.mediatipState == task.mediatipState)) ;

    return result;

  }

  getcurrentActionButtons(datarow: IMediaTip): IActionbutton[] {
    const actions = this.getactionButtons(datarow).filter(t => this.canAction(datarow, t.label));
    return actions;
  }

  /**Buttons generieren nach Möglichkeiten und Rechtesystem (soma/user) */
  getactionButtons(tip: IMediaTip): IActionbutton[] {
    this.actionbtns = new Array<IActionbutton>()

    //TODO: Nachrichten sind noch in Planung.. -> nur Bubbles zur Zeit !!!
    /*
    this.actionbtns.push(<IActionbutton>
      {
        mediatip: tip,
        label: "Nachrichten",
        disabled: (row, label) => { return this.IsDisabled(row, label); },

        icon: "chat_bubble_outline",
        tooltip: "Nachrichten",
        action: (row) => { this.showMessages(row); },
      });
    */
    this.actionbtns.push(<IActionbutton>
      {
        mediatip: tip,
        label: "Bearbeiten",
        disabled: (row, label) => { return this.IsDisabled(row, label); },
        severity : 'info',
        icon: "edit",
        tooltip: "Bearbeiten",
        action: (row) => { this.editMediatip(row); }
      });

    this.actionbtns.push(<IActionbutton>
      {
        mediatip: tip,
        label: "Verwerfen",
        severity : 'info',
        disabled: (row, label) => { return this.IsDisabled(row, label); },
        icon: "undo",
        tooltip: "Verwerfen des Medientipps",
        action: (row) => { this.rejectMediatip(row); }
      });

    this.actionbtns.push(<IActionbutton>
      {
        mediatip: tip,
        label: "Verschicken",
        severity : 'success',
        disabled: (row, label) => { return this.IsDisabled(row, label); },
        icon: "forward_to_inbox",
        tooltip: "Verschicken",
        action: (row) => { this.sendMediatip(row); }
      });
    this.actionbtns.push(<IActionbutton>
      {
        mediatip: tip,
        severity : 'success',
        label: "Freigabe",
        disabled: (row, label) => { return this.IsDisabled(row, label); },
        icon: "send",
        tooltip: "Freigeben",
        action: (row) => { this.releaseMediatip(row); }
      });
    this.actionbtns.push(<IActionbutton>
      {
        mediatip: tip,
        label: "Anzeigen",
        disabled: (row, label) => { return this.IsDisabled(row, label); },
        icon: "visibility",
        severity : 'info',
        tooltip: "Anzeigen",
        action: (row) => { this.showMediatip(row); }
      });
    this.actionbtns.push(<IActionbutton>
      {
        mediatip: tip,
        label: "Löschen",
        severity : 'warn',
        disabled: (row, label) => { return this.IsDisabled(row, label); },
        icon: "delete",
        tooltip: "Löschen",
        action: (row) => { this.deleteMediatip(row); }
      });

    return this.actionbtns;
  }

  /**Benachrichtigungshinweis z.B. 1 */
  getNotification(row: IMediaTip, label: string): string {
    if (!this.isManager) return ""; // auf Manager beschränkt
    if (label.toLowerCase() == "bearbeiten" && this.notifications) {
      const lookup = this.notifications.filter(t => t.parentId == row.id)[0];
      if (lookup == null) return "";
      let cnt = 0;
      if (lookup.targetUserId == this.authUser.id) {
        cnt = 1;
      }
      return cnt > 0 ? "!" : "";
    } else return "";
  }


  /**NUR TEST  */
  showMessages(row: IMediaTip) {

    // Anzeige der Nachrichen die der User bekommen hat
    const p = <MessageParamter>{
      targetUserId: this.authUser.id, targetUserName: this.authUser.name, type: MessageTypeEnum.Medientipp, parentId: row.id,
      correspondUserId: (this.isManager ? row.creatingUserId : row.targetUserId),
      correspondUserName: (this.isManager ? row.creatingUserName : row.targetUserName)
    };
    const ref = this.dialogService.open(MessageEditDialogComponent,
      {
        header: "Nachrichten " + (row.bubData != undefined && row.bubData.titel != undefined ? row.bubData.titel : row.ean),
        dismissableMask: false,
        width: '1024px',
        closable: true,
        height: 'auto',
        data: { p }
      });
  }

  /**Disabled Status setzen */
  IsDisabled(row: IMediaTip, label: string): boolean {
    try {
      switch (label.toLowerCase()) {
        case "freigabe":
          if (row.mediaPresences.filter(t => this.getPresenceError(t).length > 0).length > 0) {
            return true;
          }
        case "verschicken":
          if (row.mediaPresences.filter(t => this.getPresenceError(t).length > 0).length > 0) {
            return true;
          }
          break;
      }
      return false;
    } catch (e) {
      console.debug(e.toString());
      return false;
    }
  }


  sendMediatip(row: IMediaTip) {
    this.confirmationsService.confirm({
      message: "Verschicken des Medientipps " + row.ean + ' ?',
      acceptLabel: 'Medientipp versenden',
      accept: () => {
        const tiprow = { ...row };
        tiprow.sendDat = new Date();
        tiprow.mediatipState = MediatipState.Verschickt;
        this.store.dispatch(new UpdateMediatipAction({ mediatip: tiprow as IMediaTip, removefromStore: false }));
      }
    });
  }

  /**Verweerfen des Medientipps */
  rejectMediatip(row: IMediaTip) {
    this.confirmationsService.confirm({
      message: "Möchten Sie den Medientipp direkt verwerfen und nicht für die Filialkommunikation freigeben?",
      acceptLabel: "Verwerfen",
      accept: () => {
        const tiprow = { ...row };
        tiprow.mediatipState = MediatipState.Verworfen;
        this.store.dispatch(new UpdateMediatipAction({ mediatip: tiprow as IMediaTip, removefromStore: false }));
      }
    });

  }

  showMediatip(mediatiprow: IMediaTip) {
    const mediatip = cloneDeep(mediatiprow) as IMediaTip;
    mediatip.isReadonly = true;
    const ref = this.dialogService.open(MediatippsEditDialogComponent,
      {
        header: "Medientipp anzeigen",
        dismissableMask: false,
        contentStyle: { 'overflow-y': 'hidden' },
        width: '64rem',
        closable: true,
        height: 'auto',
        data: { mediatip }
      });
  }

  /**Menu für eine Zeile aus ermittelten Menueinträgen */
  getMenu(id: number): MenuItem[] {
    if (this.menues == undefined) return [];
    return  this.menues.filter(t => t.id === id)[0]?.menu;
  }
  /**Menue für Aktion erzeugen für die Zeile, je nach Möglichkeit */
  getmainMenu(rowData: IMediaTip) {
    const mainMenu = [];
    const enableds = this.getcurrentActionButtons(rowData);
    enableds.forEach(g => {
      const shoulddisabled = this.IsDisabled(rowData, g.label);
      mainMenu.push({ label: g.label, disabled: shoulddisabled, command: (event) => { g.action(rowData); } });
    });
    return mainMenu;
  }

  /**Je nach Art ist das Versand (Lipo)  oder Erhaltendatum (manager)*/
  getVersandDatum(rowData: IMediaTip): Date {
    if (this.isManager) return rowData.sendDat;
    if (!this.isManager) return rowData.sendDat ? rowData.sendDat : rowData.createDat;
  }
  /**Titel für Lipo und Soma unterschiedlich*/
  getTitelVersand(rowData: IMediaTip): string {
    if (this.isManager) return "Erhalten am"
    if (!this.isManager) {
      return "";  //  rowData.sendDat ? "Verschickt am": "Erstellt am";
    }
    return "";
  }


  /**Verlag kürzen wenn länger als 30 Zeichen */
  getVerlag(rowData: IMediaTip): string {
    let result = rowData.bubData ? rowData.bubData.verlag : "";
    if (result.length > 30) {
      result = result.substr(0, 25) + " ...";
    }
    return result;
  }


  /** */
  getPresenceError(rowData: IMediaPresence): string {
    try {
      let errors = "";
      if (!rowData.presenceDate) errors += "Datum fehlt<br>";
      if (!rowData.presence || rowData.presence.length == 0) errors += "Präsenztext fehlt<br>";
      if (!rowData.presenceType || rowData.presenceType.length == 0) errors += "Text für Typ fehlt<br>";
      const predate = new Date(rowData.presenceDate);
      predate.setHours(0, 0, 0, 0);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (predate < today) errors += "Datum liegt in der Vergangenheit<br>";
      return errors;
    } catch (e) {

      this.store.dispatch(new LogUsersClientErrorAction({ error: <IClientError>{ userid: "unknown", modul: 'Mediatip', error: e } }));
      return "Error";
    }
  }

  /**Prüft ob alle PresenceDates für heute gültig sind*/
  getPresenceDatesareValid(tip: IMediaTip): boolean {
    if (tip.mediaPresences == undefined) return false;
    if (tip.mediaPresences.length == 0) return false;
    let notvalidCnt = 0;
    for (let index = 0; index < tip.mediaPresences.length; index++) {
      const presence = tip.mediaPresences[index];
      if (!presence.presenceDate) continue;
      const predate = new Date(presence.presenceDate);
      predate.setHours(0, 0, 0, 0);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (predate < today) notvalidCnt++;
    }
    return !(tip.mediaPresences.length == notvalidCnt);
  }


  canAction(rowData: IMediaTip, label: string): boolean {
    try {
      switch (label.toLowerCase()) {
        case 'nachrichten':
          return rowData.mediatipState != MediatipState.In_Bearbeitung && rowData.mediatipState != MediatipState.Abgeschlossen && rowData.mediatipState != MediatipState.Verworfen;
        case 'bearbeiten':
          return (!this.isManager && rowData.mediatipState != MediatipState.Released && rowData.mediatipState != MediatipState.Verworfen && rowData.mediatipState != MediatipState.Verschickt && rowData.mediatipState != MediatipState.Abgeschlossen)
            || (this.isManager && rowData.mediatipState != MediatipState.Released
              && rowData.mediatipState != MediatipState.Verworfen
              && rowData.mediatipState != MediatipState.Abgeschlossen
              && this.getPresenceDatesareValid(rowData)
            );
        case 'verschicken':
          return !this.isManager
            && rowData.mediatipState != MediatipState.Verworfen
            && rowData.mediatipState != MediatipState.Verschickt
            && rowData.mediatipState != MediatipState.Abgeschlossen
            && rowData.mediaPresences.length > 0
            && rowData.mediaPresences.filter(t => this.getPresenceError(t).length > 0).length == 0;
        case 'anzeigen':
          return !this.canAction(rowData, "Bearbeiten");
        case 'löschen':
          return this.isAdmin
            || (!this.isManager && rowData.mediatipState != MediatipState.Verschickt && rowData.mediatipState != MediatipState.Abgeschlossen);
        case "verwerfen":
          return (this.isManager || this.isAdmin) && rowData.mediatipState != MediatipState.Released && rowData.mediatipState != MediatipState.Verworfen && rowData.mediatipState != MediatipState.Verarbeitet && rowData.mediatipState != MediatipState.Abgeschlossen;
        case "freigabe":
          var result = (this.isManager && rowData.bubData != undefined)
            && rowData.mediatipState != MediatipState.Verworfen
            && rowData.mediatipState != MediatipState.Released
            && rowData.mediatipState != MediatipState.Abgeschlossen
            && rowData.mediatipState != MediatipState.Verarbeitet
            && rowData.mediaPresences.length > 0
            && rowData.mediaPresences.filter(t => this.getPresenceError(t).length > 0).length == 0;
          return result;
        default:
          return true;
      }
    } catch (e) {
      console.debug(e.toString());
      return false;
    }
  }


  releaseMediatip(row: IMediaTip): void {
    this.confirmationsService.confirm({
      message: 'Möchten Sie den Medientipp direkt für die Filialkommunikation freigeben?',
      acceptLabel: "Freigabe",
      accept: () => {
        const tiprow = { ...row };
        tiprow.mediatipState = MediatipState.Released;
        this.store.dispatch(new UpdateMediatipAction({ mediatip: tiprow as IMediaTip, removefromStore: !this.isManager }));
      }
    });
  }


  editMediatip(mediatip: IMediaTip): void {

    const ref = this.dialogService.open(MediatippsEditDialogComponent,
      {
        header: "Medientipp bearbeiten",
        dismissableMask: false,
        width: '64rem',
        closable: true,
        height: 'auto',

        data: { mediatip }
      });
  }


  deleteMediatip(row: IMediaTip): void {

    this.confirmationsService.confirm({
      message: "Medientipp " + row.ean + '  wird gelöscht !',
      acceptLabel: 'Löschen',
      accept: () => {
        const delrow = { ...row };
        this.store.dispatch(new DeleteMediatipAction({ mediatipid: delrow.id }));
        this.store.dispatch(new DeleteSingleMessagesAction({ targetUserId: delrow.creatingUserId, messageType: MessageTypeEnum.Medientipp, id: delrow.id }));
        this.store.dispatch(new DeleteSingleMessagesAction({ targetUserId: delrow.targetUserId, messageType: MessageTypeEnum.Medientipp, id: delrow.id }));
      }
    });
  }

  newMediatip(): void {

    const mediatip: IMediaTip = {
      ean: null,
      id: 0,
      bubData: null,
      creatingUserId: null,
      createDat: null,
      creatingUserName: null,
      mediaPresences: null,
      mediatipState: MediatipState.Erstellt,
      targetUserId: null,
      targetUserName: null,
      isActive: 1,
      isReadonly: false,
      remark: null

    };
    const ref = this.dialogService.open(MediatippsEditDialogComponent,
      {
        header: "Medientipp erstellen",
        dismissableMask: false,
        width: '64rem',
        height: 'auto',
        closable: true,
        data: { mediatip }
      });

  }

}
